/**
 * @description 
 */
export default function () {
    return {
        menues: [],
        titleTopBar: '',
        items: [],
    }
}